import * as TYPES from './type';
export default {
  //课中活动问卷
  [TYPES.QUES_LIST](state, { result }) {
    state.quesList = result.result
  },
  [TYPES.QUES_INFO](state, { result, type }) {
    state.quesInfo[type] = result.result
  },
  [TYPES.ANS_LIST](state, { result, type }) {
    state.ansList = result.result
  },
}


// WEBPACK FOOTER //
// ./src/store/kzActivity/ques/mutations.js